module.exports = __webpack_public_path__ + "img/ASOP-2.73b15a09.png";